import { FormFields } from ".";

export const LOAN_REQUIREMENT_DETAILS: FormFields = {
  fields: [
    {
      name: "amount",
      label: "Loan Amount",
      type: "tel",
      validationRules: {
        required: false,
        pattern: {
          value: /^(0|[1-9]\d*)$/,
          message: "Enter a valid loan amount.",
        },
        maxLength: {
          value: 7,
          message: "Amount must be at most 7 digits",
        },
      },
    },
    {
      name: "rateOfInterest",
      label: "Rate of Interest (%)",
      type: "tel",
      validationRules: {
        required: false,
        pattern: {
          value: /^(?:[1-9][0-9]?(?:\.[0-9]{2})?|100(?:\.00)?)$/,
          message: "Rate of interest must be a valid number",
        },
      },
    },
    {
      name: "tenureInMonths",
      label: "Loan Tenure (Months)",
      type: "tel",
      validationRules: {
        required: false,
        pattern: {
          value: /^(0|[1-9]\d*)$/,
          message: "Enter a valid loan tenure.",
        },
        maxLength: {
          value: 2,
          message: "Tenure must be at most 2 digits",
        }, 
      },
    },
  ],
};
